import { useEffect } from 'react';
import { init } from '@cmctechnology/webinvest-analytics/dist/js/analytics';
import { useDispatch } from 'react-redux';
import { createConfig } from '../configuration/configuration';
import { updateAnalyticsEnabled } from '../Store/Actions';

let analyticsInitialization: ReturnType<typeof init> | undefined;

const initializeAnalytics = () => {
  if (!analyticsInitialization) {
    analyticsInitialization = init(createConfig().analytics).catch((error) => {
      analyticsInitialization = undefined;
      throw error;
    });
  }

  return analyticsInitialization;
};

export const useAnalyticsInit = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const initAnalytics = async () => {
      try {
        await initializeAnalytics();
        dispatch(updateAnalyticsEnabled(true));
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    };
    initAnalytics();
  }, []);
};
